// VIP level → badge tier, computed entirely client-side from vip_level (1..100).
// 100 levels are split into 20 tiers of 5 levels each; the 20 tiers are 5 metal
// families (Bronze/Silver/Gold/Diamond/Black, 20 levels each) × 4 star sub-ranks
// (a star every 5 levels). No backend field needed — vip_level is enough.

export type VipFamily = 'bronze' | 'silver' | 'gold' | 'diamond' | 'black';

export type VipBadgeInfo = {
  level: number; // clamped 1..100
  tier: number; // 1..20 (which 5-level band)
  family: VipFamily; // metal band
  stars: number; // 1..4 within the family
};

const FAMILIES: VipFamily[] = ['bronze', 'silver', 'gold', 'diamond', 'black'];

export function vipBadge(rawLevel: number | null | undefined): VipBadgeInfo {
  const level = Math.max(1, Math.min(100, Math.floor(Number(rawLevel) || 1)));
  const tier = Math.ceil(level / 5); // 1..20
  const family = FAMILIES[Math.min(FAMILIES.length - 1, Math.floor((level - 1) / 20))];
  const stars = Math.floor(((level - 1) % 20) / 5) + 1; // 1..4
  return { level, tier, family, stars };
}
